enum FieldType {
    text = 'text',
    textarea = 'textarea',
    email = 'email',
    phone = 'phone',
    datetime = 'datetime',
    image = 'image',
    check = 'check',
    url = 'url',
    formula = 'formula',
    linked = 'linkedField',
    lookup = 'lookup',
    number = 'number',
    uid = 'uid',
    renewal = 'renewal', // TODO - This is not a real uiType
    pointer = 'pointer',
    rollup = 'rollup'
}

export default FieldType;